import { EMPTY_KPI_VALUE } from './kpiMetric';

const formatMinutes = (minutes) => minutes.toLocaleString('ru-RU');

/**
 * Плитка «Использовано минут» из ответа `/processing/state`: те же цифры, что в карточке
 * управления обработкой на «Интеграциях».
 *
 * Лимит задаётся там же и может быть не задан (`minutesLimit: null`): тогда считать прогресс
 * не от чего, и кольца нет. Порог «исчерпан» решает сервер (`quotaExceeded`), клиент только
 * показывает его ответ: своё сравнение разошлось бы с наблюдателем квоты на дробных минутах.
 */
export const describeMinutesUsage = (state) => {
  const used = Number(state?.minutesUsed);
  if (state?.minutesUsed === null || state?.minutesUsed === undefined || !Number.isFinite(used)) {
    return { value: EMPTY_KPI_VALUE, note: null, progress: null, limit: null, isExhausted: false };
  }

  const roundedUsed = Math.round(used);
  const value = formatMinutes(roundedUsed);
  const limit = state.minutesLimit > 0 ? state.minutesLimit : null;
  if (limit === null) {
    return { value, note: 'Лимит: не задан', progress: null, limit: null, isExhausted: false };
  }

  const isExhausted = Boolean(state.quotaExceeded);
  const overrun = roundedUsed - limit;
  const note = overrun > 0
    ? `Сверх лимита: ${formatMinutes(overrun)}`
    : isExhausted
      ? 'Лимит исчерпан'
      : `Лимит: ${formatMinutes(limit)}`;

  return { value, note, progress: Math.min(100, Math.max(0, (used / limit) * 100)), limit, isExhausted };
};
